var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_921_4704)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01546 6.41406C2.37901 6.41406 2.67373 6.70878 2.67373 7.07233V20.5669C2.67373 20.9304 2.96844 21.2251 3.332 21.2251H16.8265C17.1901 21.2251 17.4848 21.5199 17.4848 21.8834V22.7611C17.4848 23.1247 17.1901 23.4194 16.8265 23.4194H1.13776C0.77421 23.4194 0.479492 23.1247 0.479492 22.7611V7.07233C0.479492 6.70878 0.77421 6.41406 1.13776 6.41406H2.01546Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3901 7.51196C11.7537 7.51196 12.0485 7.80672 12.0485 8.17032V13.4363C12.0485 13.7999 11.7537 14.0947 11.3901 14.0947H10.0734C9.70979 14.0947 9.41504 13.7999 9.41504 13.4363V8.17032C9.41504 7.80672 9.70979 7.51196 10.0734 7.51196H11.3901Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8764 5.31787C15.24 5.31787 15.5348 5.61263 15.5348 5.97622V13.4365C15.5348 13.8001 15.24 14.0948 14.8764 14.0948H13.5597C13.1961 14.0948 12.9014 13.8001 12.9014 13.4365V5.97622C12.9014 5.61263 13.1961 5.31787 13.5597 5.31787H14.8764Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3139 9.7063C18.6775 9.7063 18.9723 10.0011 18.9723 10.3647V13.4364C18.9723 13.8 18.6775 14.0948 18.3139 14.0948H16.9972C16.6336 14.0948 16.3389 13.8 16.3389 13.4364V10.3647C16.3389 10.0011 16.6336 9.7063 16.9972 9.7063H18.3139Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3249 3.23336C21.3249 2.86981 21.0302 2.57509 20.6667 2.57509H7.72067C7.35712 2.57509 7.0624 2.86981 7.0624 3.23337V16.1793C7.0624 16.5429 7.35712 16.8376 7.72067 16.8376H20.6667C21.0302 16.8376 21.3249 16.5429 21.3249 16.1793V3.23336ZM5.52643 0.380859C5.16288 0.380859 4.86816 0.675576 4.86816 1.03913V18.3736C4.86816 18.7371 5.16288 19.0319 5.52643 19.0319H22.8609C23.2244 19.0319 23.5192 18.7371 23.5192 18.3736V1.03913C23.5192 0.675577 23.2244 0.380859 22.8609 0.380859H5.52643Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_921_4704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.380859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/ReportIcon.3c3004ec002360e6e82719483bb90848.svg";
export { ForwardRef as ReactComponent };